import React from 'react'
import  { inject,observer } from 'mobx-react'
import fetch from 'isomorphic-unfetch'
import { withRouter } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'

import LayoutAdmin from '../components/admin/layoutadmin'
import Layout from '../components/layout'

import AccessNotAllowed from '../components/admin/AccessNotAllowed'
import Login from '../components/admin/login'


export function withAuthorization (WrappedComponent) {
  @inject('admin') @observer
  class AuthorizationClass extends React.Component {
    constructor (props) {
      super(props)
      this.state = {isAuthenticated:true}
    }
    async verifyToken () {
      const { cookies } = this.props
      
      this.props.admin.verifyToken(cookies.get('token'), (res) => {
       this.setState({isAuthenticated:res.success})
      })
    }
    componentDidMount () {
      this.verifyToken()
    }
    render () {
      if (this.state.isAuthenticated) {
       return <WrappedComponent {...this.props} />
      }
      else {
       return <Login />
      }
    }
  }
  return withCookies(withRouter(AuthorizationClass))
}


export function withLayoutAdmin (WrappedComponent) {
  @observer
  class LayoutAdminClass extends React.Component {
    render () {
      return (
        <Layout>
         <LayoutAdmin>
          <WrappedComponent {...this.props} />
         </LayoutAdmin>
        </Layout>
      )
    }
  }
  return LayoutAdminClass
}


export function withLayout (WrappedComponent) {
  @observer
  class LayoutClass extends React.Component {
    render () {
      return (
       <Layout>
        <WrappedComponent {...this.props} />
       </Layout>
      )
    }
  }
  return LayoutClass
}



// WEBPACK FOOTER //
// ./src/utils/hoc.js